<template>
  <Slide>
    <h1>Consejos y dudas</h1>
  </Slide>

  <Slide>
    <ul>
      <li><a href="https://www.linkedin.com/in/emagleza/">Linkedin</a></li>
      <li><a href="https://github.com/udsgit">Git</a></li>
      <li>Clases online
        <ul>
          <li><a href="https://escuelavue.es/">Escuela Vue</a></li>
          <li><a href="https://javascript.info/">Curso JS</a></li>
          <li><a href="https://www.udemy.com/">Udemy</a></li>
          <li><a href="https://codely.tv/">Codely</a></li>
        </ul>
      </li>
      <li>Libros</li>
      <li>Despliegue web
        <ul>
          <li><a href="https://www.heroku.com/">Heroku</a></li>
          <li><a href="https://www.netlify.com/">Netlify</a></li>
          <li><a href="https://pages.github.com/">GitHub Pages</a></li>
        </ul>
      </li>

    </ul>
    <aside class="notes">
      <div>- Mochila Git</div>
    </aside>
  </Slide>
</template>

<script>
import Slide from "@/components/Slide";
export default {
name: "Dudas",
  components: {Slide}
}
</script>

<style scoped>

</style>